import React from 'react'
import SideNav from './SideNav'

const LandscapeDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-landscape-design-services parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Landscape Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/landscape-design-service.jpg" alt="Landscape Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      At <b>MeHome</b>, we specialize in crafting outdoor environments that bring
                      nature and architecture together. Our <b>Landscape Design Services</b> turn
                      open spaces into peaceful, beautiful, and functional environments where you
                      can relax, entertain, and connect with nature.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Designing <span>Nature with Purpose & Beauty</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Whether it’s a residential garden, terrace landscape, or corporate outdoor
                      space, our team brings creativity, technical precision, and sustainability
                      into every detail.
                    </p>

                    <ul>
                      <li>Residential, terrace, and rooftop gardens tailored for modern living.</li>
                      <li>Custom hardscaping including stonework, pathways, and pergolas.</li>
                      <li>Water features and lighting to enhance ambience.</li>
                      <li>Low-maintenance, eco-friendly designs that last.</li>
                      <li>Complete execution from concept to completion.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> Landscape Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Residential Landscaping</h3>
                          <p>
                            Beautifully planned green spaces that enhance your home’s natural
                            surroundings — perfect for relaxation, family time, or outdoor gatherings.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">💧</div>
                        <div className="why-choose-item-content">
                          <h3>Water Features</h3>
                          <p>
                            Bring peace and elegance to your outdoor area with decorative fountains,
                            mini waterfalls, or ponds designed for soothing ambience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🪨</div>
                        <div className="why-choose-item-content">
                          <h3>Hardscaping</h3>
                          <p>
                            Combining form and function, we use stone, wood, and natural textures
                            to create walkways, walls, and seating areas with timeless charm.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🌺</div>
                        <div className="why-choose-item-content">
                          <h3>Vertical & Terrace Gardens</h3>
                          <p>
                            Transform compact urban spaces into lush, vibrant green walls and rooftop gardens.
                            Perfect for modern apartments and offices.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Lighting & Irrigation</h3>
                          <p>
                            Energy-efficient lighting and smart watering systems that keep your
                            landscape looking fresh and radiant day or night.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Recent <span> Landscape Projects</span>
                      </h2>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/landscape1.jpg" alt="Landscape Project 1" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/landscape2.jpg" alt="Landscape Project 2" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/landscape3.jpg" alt="Landscape Project 3" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Landscape Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>6+ Years of Proven Expertise</b> in interior & exterior design.</li>
                        <li><b>End-to-End Service</b> – design, execution, and maintenance.</li>
                        <li><b>Eco-Friendly Practices</b> – sustainable landscaping solutions.</li>
                        <li><b>High-Quality Craftsmanship</b> – durable, weather-resistant finishes.</li>
                        <li><b>On-Time Project Completion</b> – efficient, transparent, and professional.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default LandscapeDesigns
